import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import App from './App.vue';
import less from "less";
import VueAwesomeSwiper from "vue-awesome-swiper/dist/vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import $ from 'jquery';
import './assets/icon/iconfont/iconfont.css';
import directive from '../utils/change';
import '../src/assets/public.css';
import store from './store';

// 使用juqery(挂载)
window.jQuery = $;
window.$ = $;

Vue.use(ElementUI);
Vue.use(less);
Vue.use(VueAwesomeSwiper);
Vue.directive("change",directive);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});

// 路由导航守卫==>路由跳转后，回到页面顶部
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})